export const KEY_USER = 'user'
export const KEY_TOKEN = 'accessToken'
export const SEARCH_FILTER = 'searchFilter'
